// extracted by mini-css-extract-plugin
export default {"container":"RoutesContainer_container__giHcT"};